// material ui icons
import BoltIcon from '@mui/icons-material/Bolt';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import WaterDropIcon from '@mui/icons-material/WaterDrop';

const METER_TYPE_CONFIG = {
  power: { Icon: BoltIcon, color: 'power.main' },
  water: { Icon: WaterDropIcon, color: 'water.main' },
  heat: { Icon: LocalFireDepartmentIcon, color: 'heat.main' },
  solar: { Icon: SolarPowerIcon, color: 'power.main' },
};

const MeterTypeIcon = ({ type, size = 40, sx, ...props }) => {
  const config = METER_TYPE_CONFIG[type];
  if (!config) return null;

  const { Icon, color } = config;
  return <Icon sx={{ fontSize: size, color, ...sx }} {...props} />;
};

export default MeterTypeIcon;
